/**
 * Created by saint on 4/24/2017.
 */
export class DateFilter {
  from?: Date;
  to?: Date;
}
